import { SiteLicense } from "../types/api.types";
import type { SiteCategoriesResponse } from "./backend-types";

/** Whether any site has a premium license. `undefined` while categories are loading. */
export function hasPremiumSite(
  siteCategories: ReadonlyArray<SiteCategoriesResponse> | undefined
): boolean | undefined {
  return siteCategories?.some((site) => site.license === SiteLicense.premium);
}
